import "core-js/modules/es.number.constructor.js";
import RichText from '~/components/ui/RichText';
import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'ItemBlockEnumeration',
  components: {
    RichText: RichText,
    AzImg: AzImg
  },
  props: {
    title: String,
    description: Object,
    number: Number,
    image: {
      type: Object,
      default: function _default() {}
    },
    classes: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(_ref) {
    var number = _ref.number;
    var itemListRef = ref();
    onMounted(function () {
      var iElement = document.createElement('i');
      iElement.setAttribute('aria-hidden', 'true');
      iElement.textContent = number;
      iElement.classList.add('list-item__number');
      itemListRef.value.$el.prepend(iElement);
    });
    var options = {
      renderNode: {
        paragraph: function paragraph(node, next) {
          return "\n        <p class=\"list-item__description\">".concat(next(node.content), "</p>");
        }
      }
    };
    return {
      options: options,
      itemListRef: itemListRef
    };
  }
});